import { init as initUsersStats } from './../components/user_stats'
import { init as initAdminPanel } from './../components/admin_panel'
import { init as initMessageUser } from './../components/message_user'

export const init = () => {
  initUsersStats()
  initAdminPanel()
  initMessageUser()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/users/users.js